import React, { PureComponent } from 'react';
import moment, { Moment } from 'moment';
import { DayPicker, AnalyticsProps } from '@inplayer-org/inplayer-ui';

export interface Props extends AnalyticsProps {
  isOutsideRange?: (day: number) => any;
  handleDateChange: (date: Moment) => any;
  date?: any;
  disabled?: boolean;
  onDatePickerFocusChange?: (focused: boolean) => void;
  onCloseDatePicker?: () => any;
  disablePastDays?: boolean;
  displayFormat?: string;
}

interface State {
  date: Moment;
  focused: boolean;
}

export default class SingleDayPicker extends PureComponent<Props, State> {
  state = { date: moment(), focused: false };

  componentDidMount() {
    const { date } = this.props;
    this.setState({ date: date || null });
  }

  componentDidUpdate(prevProps: Props) {
    const { date } = this.props;
    const { date: prevDate } = prevProps;

    if (prevDate !== date) {
      this.setState({ date });
    }
  }

  getDateValues = () => {
    const { date } = this.state;
    return { date };
  };

  onDateChange = (date: any) => {
    const { handleDateChange } = this.props;
    this.setState(
      {
        date,
      },
      () => handleDateChange(date)
    );
  };

  onFocusChange = (focused: any) => {
    const { onDatePickerFocusChange } = this.props;
    const { focused: isFocused } = focused;
    this.setState({ focused: isFocused });
    onDatePickerFocusChange && onDatePickerFocusChange(!!focused);
  };

  render() {
    const { focused, date } = this.state;
    const { isOutsideRange, disabled, onCloseDatePicker, disablePastDays, displayFormat } = this.props;

    return (
      <DayPicker
        isOutsideRange={isOutsideRange}
        onDateChange={this.onDateChange}
        onFocusChange={this.onFocusChange}
        focused={focused}
        date={date}
        disabled={disabled}
        onClose={onCloseDatePicker}
        disablePastDays={disablePastDays}
        displayFormat={displayFormat}
      />
    );
  }
}
